/* product.js — variant selection, gallery, purchase mode, quantity, live pricing
   (per-serving, in-button total, pack Save %). */
(function () {
  'use strict';
  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  const P = ((window.theme && window.theme.strings && window.theme.strings.product) || {});
  const T = (window.theme && window.theme.t) || function (s, v) { return s == null ? '' : (!v ? s : s.replace(/\[\[(\w+)\]\]/g, function (m, k) { return k in v ? v[k] : m; })); };

  let variants = [];
  // The variant JSON <script> is rendered after the section, so query the document, not root.
  try { variants = JSON.parse((document.querySelector('[data-variant-json]') || {}).textContent); } catch (e) {}

  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const idInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-price]');
  const compareEl = root.querySelector('[data-price-compare]');
  const saveEl = root.querySelector('[data-price-save]');
  const servingEl = root.querySelector('[data-price-serving]');
  const bnplEls = root.querySelectorAll('[data-bnpl]');
  const atc = root.querySelector('[data-atc]');
  const atcLabel = root.querySelector('[data-atc-label]');
  const atcPrice = root.querySelector('[data-atc-price]');
  const atcCompare = root.querySelector('[data-atc-compare]'); // only present when the "show sale price in button" setting is on

  // Rating → reviews: clicking the star rating scrolls to the review widget/section.
  // Target is resolved on click (the review app renders after this script) — works for
  // Judge.me (.jdgm-rev-widg) or the theme's Reviews section, whichever is present.
  const reviewsLink = root.querySelector('[data-reviews-link]');
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function (e) {
      const target = document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews') ||
        Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section"]')).find(function (s) { return /review/i.test(s.id); });
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }
  // sticky add-to-cart bar (optional; rendered after the section)
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const stickyPrice = stickyBar && stickyBar.querySelector('[data-sticky-price]');
  const stickyAdd = stickyBar && stickyBar.querySelector('[data-sticky-add]');
  const stickyAddLabel = stickyBar && stickyBar.querySelector('[data-sticky-add-label]');
  const mainImgs = root.querySelectorAll('[data-main]');
  // swipeable main gallery (mobile ≤849px): slides live in a scroll-snap row there,
  // so programmatic selection scrolls instead of toggling visibility
  const mainEl = root.querySelector('.product__main');
  const galleryMQ = window.matchMedia('(max-width:849px)');
  function scrollMainTo(i) {
    if (!mainEl || !galleryMQ.matches || i == null) return;
    const item = mainEl.querySelector('[data-main="' + i + '"]');
    if (item) mainEl.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  }
  // mobile slide dots (optional via section setting)
  const gdots = root.querySelectorAll('[data-gdot]');
  function syncDots(i) { gdots.forEach((d) => d.classList.toggle('is-active', +d.dataset.gdot === i)); }
  const spInput = root.querySelector('input[name="selling_plan"]');
  const qtyField = root.querySelector('[data-qty] input');
  const stockEl = root.querySelector('[data-stock]');
  const stockText = root.querySelector('[data-stock-text]');
  const lowStock = parseInt(root.dataset.lowStock, 10) || 10;
  // back-in-stock notify block (sibling of the buy form; shown only when the variant is unavailable)
  const bis = root.querySelector('[data-bis]');
  const bisBody = root.querySelector('[data-bis-body]');
  const bisSuccess = bis && bis.querySelector('.product__bis-msg--ok');
  const prodTitle = ((root.querySelector('.product__title') || {}).textContent || '').trim();
  // a successful submit reloads the page; keep the confirmation visible regardless of variant state
  if (bis && bisSuccess) { bis.hidden = false; }

  // Pack option index, if any. serving_count is the per-pack-unit (e.g. per-pouch) base;
  // total servings = base × the pack count parsed from the pack option value ("3 pouches" → 3).
  const packOptEl = root.querySelector('[data-pack-option]');
  const packIndex = packOptEl ? +packOptEl.dataset.optionIndex : -1;
  // pack math shared by the pill Save-% notes and the ATC's derived strike price:
  // units parsed from the pack value ("3 pouches" → 3), baseline = worst per-unit price
  function packUnitsOf(v) { return packIndex >= 0 && v ? ((v.options[packIndex].match(/\d+/) || [])[0] * 1 || 1) : 1; }
  const packBaseUnit = packIndex >= 0 && variants.length
    ? Math.max(...variants.map((x) => x.priceN / packUnitsOf(x)))
    : 0;

  function formatMoney(cents) {
    const value = cents / 100;
    const withCommas = (n, d) => { const p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return d ? p.join('.') : p[0]; };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => {
      if (k === 'amount_no_decimals') return withCommas(value, 0);
      if (k === 'amount_with_comma_separator') return withCommas(value, 2).replace(/,/g, '§').replace(/\./, ',').replace(/§/g, '.');
      if (k === 'amount_no_decimals_with_comma_separator') return withCommas(value, 0).replace(/,/g, '.');
      return withCommas(value, 2);
    });
  }

  // BNPL / "pay in X" messaging — keep each placement's amount in sync with the variant price.
  // Afterpay/Klarna placements recompute the breakdown themselves once their amount changes;
  // the generic mode just divides by the configured number of payments.
  function updateBnpl(cents) {
    bnplEls.forEach(function (el) {
      const provider = el.getAttribute('data-bnpl-provider');
      if (provider === 'afterpay') {
        const ap = el.querySelector('afterpay-placement');
        if (ap) ap.setAttribute('data-amount', (cents / 100).toFixed(2));
      } else if (provider === 'klarna') {
        const kl = el.querySelector('klarna-placement');
        if (kl) kl.setAttribute('data-purchase-amount', String(cents));
        if (window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh) window.Klarna.OnsiteMessaging.refresh();
      } else {
        const n = parseInt(el.getAttribute('data-bnpl-n'), 10) || 4;
        const amtEl = el.querySelector('[data-bnpl-amount]');
        if (amtEl) amtEl.textContent = formatMoney(Math.round(cents / n));
      }
    });
  }

  function selectedOptions() {
    return [...root.querySelectorAll('.product__option')].map((opt) => {
      const checked = opt.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function subscribeActive() {
    const sub = root.querySelector('input[name="selling_plan"]');
    return sub && sub.checked;
  }

  function currentVariant() {
    const opts = selectedOptions();
    let v = variants[0];
    if (opts.length && opts[0] !== null) {
      v = variants.find((x) => x.options.every((o, i) => o === opts[i])) || v;
    }
    return v;
  }

  function updateStock(v) {
    if (!stockEl) return;
    let state = 'in';
    if (!v.available) state = 'out';
    else if (v.invManaged && v.inv <= 0) state = 'out';
    else if (v.invManaged && v.inv <= lowStock) state = 'low';
    stockEl.classList.remove('product__stock--in', 'product__stock--low', 'product__stock--out');
    stockEl.classList.add('product__stock--' + state);
    if (stockText) {
      if (state === 'out') stockText.textContent = P.out_of_stock || 'Out of stock';
      else if (state === 'low') stockText.textContent = T(P.low_stock || 'Low stock — only [[quantity]] left', { quantity: v.inv });
      else stockText.textContent = P.in_stock || 'In stock';
    }
  }

  function updateVariant() {
    const v = currentVariant();
    if (!v) return;
    if (idInput) idInput.value = v.id;
    updateStock(v);

    const sub = subscribeActive() && v.subN;
    const unit = sub ? v.subN : v.priceN;
    const qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);

    if (priceEl) priceEl.textContent = formatMoney(unit);
    updateBnpl(unit);

    // strike-through + Save badge: subscribe discount first, else compare-at sale
    let was = 0;
    if (sub && v.priceN > unit) was = v.priceN;
    else if (v.compareN > unit) was = v.compareN;
    if (compareEl) { compareEl.textContent = was ? formatMoney(was) : ''; compareEl.hidden = !was; }
    if (saveEl) {
      if (was) { saveEl.textContent = T(P.save_percent || 'Save [[percent]]%', { percent: Math.round((was - unit) / was * 100) }); saveEl.hidden = false; }
      else saveEl.hidden = true;
    }

    if (servingEl) {
      const packCount = packIndex >= 0 ? ((v.options[packIndex].match(/\d+/) || [])[0] * 1 || 1) : 1;
      const totalServings = v.servings * packCount;
      if (totalServings > 0) { servingEl.textContent = formatMoney(unit / totalServings) + '/serving'; servingEl.hidden = false; }
      else servingEl.hidden = true;
    }

    if (atc) {
      atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? (P.add_to_cart || 'Add to cart') : (P.sold_out || 'Sold out');
      if (atcPrice) atcPrice.textContent = v.available ? '· ' + formatMoney(unit * qty) : '';
      // compare-at (sale) price in the button — reuses `was`, scaled to the chosen qty.
      // No compare-at? Fall back to pack math (units × baseline per-unit) so the button
      // agrees with the pills' Save % on permanent bundle pricing.
      if (atcCompare) {
        let atcWas = was;
        if (!atcWas && packBaseUnit) {
          const derived = Math.round(packBaseUnit * packUnitsOf(v));
          if (derived > unit) atcWas = derived;
        }
        const show = v.available && atcWas;
        atcCompare.textContent = show ? formatMoney(atcWas * qty) : '';
        atcCompare.hidden = !show;
      }
    }

    if (stickyBar) {
      if (stickyPrice) stickyPrice.textContent = formatMoney(unit);
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (stickyAddLabel) stickyAddLabel.textContent = v.available ? (P.add_to_cart || 'Add to cart') : (P.sold_out || 'Sold out');
    }

    if (mainImgs.length && v.media != null) {
      mainImgs.forEach((img) => img.classList.toggle('is-active', +img.dataset.main === v.media));
      root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', +t.dataset.thumb === v.media));
      syncDots(v.media);
      scrollMainTo(v.media);
      syncGalleryVideos();
    }

    // back-in-stock notify: reveal when the chosen variant can't be bought (unless a confirmation is already showing)
    if (bis && !bisSuccess) bis.hidden = v.available;
    if (bisBody) {
      const optStr = selectedOptions().filter(Boolean).join(' / ');
      bisBody.value = 'Back-in-stock request: ' + prodTitle + (optStr ? ' — ' + optStr : '');
    }
  }

  // option selection (colour swatches, pack pills, text radios)
  root.querySelectorAll('.product__option input').forEach((input) => {
    input.addEventListener('change', () => {
      const opt = input.closest('.product__option');
      opt.querySelectorAll('label').forEach((l) => l.classList.toggle('is-active', l.contains(input)));
      const label = opt.querySelector('[data-option-label]');
      if (label) label.textContent = input.value;
      updateVariant();
    });
  });

  // purchase mode (one-time vs subscribe)
  root.querySelectorAll('.product__pmode input').forEach((input) => {
    input.addEventListener('change', () => {
      root.querySelectorAll('.product__pmode').forEach((p) => p.classList.toggle('is-active', p.contains(input)));
      if (spInput) spInput.disabled = !(input.name === 'selling_plan');
      updateVariant();
    });
  });

  // play the active slide's native video, pause the others (autoplay-on-view)
  function syncGalleryVideos() {
    mainImgs.forEach((item) => {
      const vid = item.querySelector('video');
      if (!vid) return;
      if (item.classList.contains('is-active')) { const p = vid.play(); if (p && p.catch) p.catch(() => {}); }
      else { vid.pause(); }
    });
  }

  // thumbnails
  root.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const i = +thumb.dataset.thumb;
      root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      mainImgs.forEach((img) => img.classList.toggle('is-active', +img.dataset.main === i));
      syncDots(i);
      scrollMainTo(i);
      syncGalleryVideos();
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  });

  // mobile swipe: as the snap row scrolls, mirror the visible slide onto the thumbs
  // and the is-active state (which also drives per-slide video autoplay)
  if (mainEl) {
    let swipeRaf;
    mainEl.addEventListener('scroll', () => {
      if (!galleryMQ.matches || !mainEl.clientWidth) return;
      cancelAnimationFrame(swipeRaf);
      swipeRaf = requestAnimationFrame(() => {
        const i = Math.round(mainEl.scrollLeft / mainEl.clientWidth);
        root.querySelectorAll('[data-thumb]').forEach((t) => {
          const on = +t.dataset.thumb === i;
          if (on && !t.classList.contains('is-active')) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          t.classList.toggle('is-active', on);
        });
        mainImgs.forEach((img) => img.classList.toggle('is-active', +img.dataset.main === i));
        syncDots(i);
        syncGalleryVideos();
      });
    }, { passive: true });
  }

  // dot taps mirror thumb taps
  gdots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const i = +dot.dataset.gdot;
      root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', +t.dataset.thumb === i));
      mainImgs.forEach((img) => img.classList.toggle('is-active', +img.dataset.main === i));
      syncDots(i);
      scrollMainTo(i);
      syncGalleryVideos();
    });
  });

  // thumbnail slider: cap the rail to the main image height and reveal chevrons when it overflows
  (function thumbSlider() {
    const wrap = root.querySelector('[data-thumbs]');
    const track = root.querySelector('[data-thumbs-track]');
    const mainBox = root.querySelector('.product__main');
    if (!wrap || !track || !mainBox) return;
    const prevBtn = root.querySelector('[data-thumbs-prev]');
    const nextBtn = root.querySelector('[data-thumbs-next]');
    // thumbs-below is a horizontal row at every width; thumbs-left is vertical only on desktop
    const gallery = root.querySelector('[data-gallery]');
    const below = gallery && gallery.classList.contains('product__gallery--thumbs-below');
    const vertical = () => !below && window.matchMedia('(min-width: 850px)').matches;

    // read-only: chevron enabled/disabled + overflow flag. Safe to run on every scroll —
    // it must NOT write layout (e.g. maxHeight), or it cancels in-flight smooth scrolling.
    function updateArrows() {
      const v = vertical();
      const size = v ? track.scrollHeight - track.clientHeight : track.scrollWidth - track.clientWidth;
      const pos = v ? track.scrollTop : track.scrollLeft;
      wrap.classList.toggle('is-overflowing', size > 2);
      if (prevBtn) { prevBtn.hidden = false; prevBtn.disabled = pos <= 1; }
      if (nextBtn) { nextBtn.hidden = false; nextBtn.disabled = pos >= size - 1; }
    }
    // layout pass: cap the rail to the main image. Only writes when the value changes,
    // and never runs from the scroll handler, so smooth chevron scrolls aren't interrupted.
    function measure() {
      const cap = vertical() ? mainBox.clientHeight + 'px' : '';
      if (track.style.maxHeight !== cap) track.style.maxHeight = cap;
      updateArrows();
    }
    function nudge(dir) {
      const v = vertical();
      const max = v ? track.scrollHeight - track.clientHeight : track.scrollWidth - track.clientWidth;
      const cur = v ? track.scrollTop : track.scrollLeft;
      const step = (v ? track.clientHeight : track.clientWidth) * 0.8;
      const target = Math.max(0, Math.min(max, cur + dir * step));
      if (v) track.scrollTop = target; else track.scrollLeft = target;
      updateArrows(); // don't rely on the scroll event firing for programmatic scrolls
    }
    if (prevBtn) prevBtn.addEventListener('click', () => nudge(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => nudge(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(mainBox);
    measure();
  })();

  // quantity stepper
  const qty = root.querySelector('[data-qty]');
  if (qty) {
    qty.querySelector('[data-qty-down]').addEventListener('click', () => { qtyField.value = Math.max(1, (+qtyField.value || 1) - 1); updateVariant(); });
    qty.querySelector('[data-qty-up]').addEventListener('click', () => { qtyField.value = (+qtyField.value || 1) + 1; updateVariant(); });
    qtyField.addEventListener('input', updateVariant);
  }

  // pack pills: derive Save % from per-unit price vs the dearest pack
  (function packNotes() {
    const packWrap = root.querySelector('[data-pack-option]');
    if (!packWrap) return;
    const packIndex = +packWrap.dataset.optionIndex;
    const labels = [...packWrap.querySelectorAll('.product__pack')];
    const rows = labels.map((label) => {
      const value = label.querySelector('input').value;
      const count = (value.match(/\d+/) || [])[0] * 1 || 1;
      const v = variants.find((x) => x.options[packIndex] === value);
      return { note: label.querySelector('[data-pack-note]'), perUnit: v ? v.priceN / count : null };
    });
    const base = Math.max(...rows.map((r) => r.perUnit || 0));
    if (!base) return;
    rows.forEach((r) => {
      if (!r.note || r.perUnit == null) return;
      const save = Math.round((1 - r.perUnit / base) * 100);
      r.note.textContent = save > 0 ? 'Save ' + save + '%' : '–';
    });
  })();

  // free-shipping seal: show on any pack whose own price already clears the free-ship threshold
  (function packFreeShip() {
    const packWrap = root.querySelector('[data-pack-option]');
    if (!packWrap) return;
    const threshold = +packWrap.dataset.freeShip || 0;
    if (!threshold) return;
    const packIndex = +packWrap.dataset.optionIndex;
    packWrap.querySelectorAll('.product__pack').forEach((label) => {
      const input = label.querySelector('input');
      const v = input && variants.find((x) => x.options[packIndex] === input.value);
      const seal = label.querySelector('[data-pack-ship]');
      if (seal) seal.hidden = !(v && v.priceN >= threshold);
    });
  })();

  // sticky add-to-cart bar: reveal once the real buy box has scrolled above the
  // viewport; its Add button delegates to the real ATC so selling plan / qty / id carry over.
  if (stickyBar) {
    if (stickyAdd) stickyAdd.addEventListener('click', () => { if (atc && !atc.disabled) atc.click(); });
    const anchor = root.querySelector('.product__buy') || atc;
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        const e = entries[0];
        // show only when the buy box is gone ABOVE the fold (top < 0), not before reaching it
        const past = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.hidden = !past;
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }, { threshold: 0 }).observe(anchor);
    }
  }

  // Deferred video: the gallery renders a poster + play button; swap in the real
  // <video>/<iframe> only on first click so media never loads until it's wanted.
  root.querySelectorAll('[data-deferred-media]').forEach((wrap) => {
    const poster = wrap.querySelector('[data-deferred-poster]');
    const tpl = wrap.querySelector('[data-deferred-template]');
    if (!poster || !tpl) return;
    poster.addEventListener('click', () => {
      wrap.appendChild(tpl.content.cloneNode(true));
      poster.remove();
      const media = wrap.querySelector('video, iframe');
      if (!media) return;
      if (media.tagName === 'VIDEO') { const p = media.play(); if (p && p.catch) p.catch(() => {}); }
      else { try { const u = new URL(media.src); u.searchParams.set('autoplay', '1'); media.src = u.toString(); } catch (e) {} }
    }, { once: true });
  });

  // Zoom lightbox: open the active image at full resolution from any magnifier button.
  const lb = document.querySelector('[data-lightbox]');
  if (lb) {
    const lbImg = lb.querySelector('[data-lightbox-img]');
    const openLb = (src) => { if (!src || !lbImg) return; lbImg.src = src; lb.hidden = false; lb.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; };
    const closeLb = () => { lb.hidden = true; lb.setAttribute('aria-hidden', 'true'); if (lbImg) lbImg.src = ''; document.documentElement.style.overflow = ''; };
    root.querySelectorAll('[data-zoom-open]').forEach((b) => {
      b.addEventListener('click', () => {
        const item = b.closest('.product__main-item');
        const img = item && item.querySelector('img[data-zoom-src]');
        openLb(img && img.getAttribute('data-zoom-src'));
      });
    });
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target === lbImg || e.target.closest('[data-lightbox-close]')) closeLb(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
  }

  updateVariant();
})();
